<span class="version">{{ "version" | translate : { version: version } }}</span>
